export const parseJSON = (obj) => {
    try {
        return obj ? JSON.parse(obj) : undefined;
    }
    catch {
        return undefined;
    }
};
export const parseSerializedValue = (wrappedValue) => {
    return wrappedValue ? Number(wrappedValue.serializedValue) : undefined;
};
export const parseFromHtmlString = (text, defaultValue) => {
    if (!text) {
        return defaultValue;
    }
    try {
        return (text?.replace(/&#x(\w+);/g, (match, hex) => String.fromCharCode(parseInt(hex, 16)) || match) ?? defaultValue);
    }
    catch {
        return text || defaultValue;
    }
};
//# sourceMappingURL=parsing.js.map